import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { closeOpenWidth } from 'src/app/shared/animations/open-close.animations';
import { MailInfo } from 'src/app/shared/model/mail-info.model';
import { MatchingOffer } from 'src/app/shared/model/matching-offer.model';
import { SearchCondition } from 'src/app/shared/model/search-condition.model';
import { SortOrder } from 'src/app/shared/enum/sort-order';
import { PageEnums } from 'src/app/shared/enum/page-enums';

import 'rxjs/add/observable/fromEvent';
import { Subscription } from 'rxjs/Subscription';
import { Subject, asyncScheduler } from 'rxjs';
import { throttleTime } from 'rxjs/operators';
@Component({
  selector: 'app-overview-list',
  templateUrl: './overview-list.component.html',
  styleUrls: ['./overview-list.component.scss'],
  animations: [closeOpenWidth()],
  host: {
    '(document:keydown)': 'handleKeyboardEvents($event)'
  }
})
export class OverviewListComponent implements OnInit, OnDestroy {
  @Input() mails: MailInfo[];
  @Input() mailType: string;
  @Input() page: string;
  @Input() sharedAccountOffers: MatchingOffer[]; // 共通アカウント（USER_CODE）に紐付くオファーを取得
  @Input() offeredMailIds: number[]; // offersの中のmail_id
  @Input() pageNumber: number;
  @Input() readMails: number[] = [];
  @Input() loading = false;
  @Output() loadNextPage = new EventEmitter<void>();
  @Output() loadMailDetail = new EventEmitter<number>();
  @Input() searchParams: SearchCondition;
  @Input() sortParams: {
    date_order: number;
    fee_order: number;
    age_order: number;
  };
  @Output() sortParamsChange = new EventEmitter<{
    date_order: number;
    fee_order: number;
    age_order: number;
  }>();
  @Input() openMailId = -1;
  @Output() openMailIdChange = new EventEmitter<number>();

  focusOnTable = false;
  senderNameFirst = true;
  subjectFirst = true;

  pageEnums = PageEnums;
  subscription: Subscription;

  showDetail$ = new Subject<{ id: number; type: 'single' | 'double' }>();
  constructor() {}

  ngOnInit() {
    this.subscription = this.showDetail$
      .pipe(
        throttleTime(200, asyncScheduler, {
          leading: false,
          trailing: true
        })
      )
      .subscribe(params => {
        const { id, type } = params;
        if (type === 'single') {
          this.openMailDetail(id);
        }
      });
  }

  ngOnDestroy() {
    // コンポーネントが破棄されるときにサブスクリプションを解除
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  handleKeyboardEvents(event: KeyboardEvent) {
    if (
      this.focusOnTable &&
      ['ArrowUp', 'ArrowDown'].includes(event.code)
    ) {
      event.preventDefault();
      const mailId = this.openMailId + (event.code === 'ArrowUp' ? -1 : 1);
      this.scrollToPosition('mailid' + mailId);
      this.openMailDetail(mailId);
    }
  }

  sortOrderChange(type: 'date' | 'fee' | 'age', order: number) {
    this.scrollToPosition('mailid0');
    this.sortParams = {
      date_order: SortOrder.unSort,
      fee_order: SortOrder.unSort,
      age_order: SortOrder.unSort
    };
    if (order === SortOrder.unSort) {
      this.sortParams.date_order = SortOrder.desc;
    } else {
      switch (type) {
        case 'date':
          this.sortParams.date_order = order;
          break;
        case 'fee':
          this.sortParams.fee_order = order;
          break;
        case 'age':
          this.sortParams.age_order = order;
          break;
      }
    }

    this.sortParamsChange.emit(this.sortParams);
  }

  clickMail(mailId: number) {
    this.showDetail$.next({ id: mailId, type: 'single' });
  }
  openMailDetail(mailId: number) {
    if (
      this.openMailId === mailId ||
      mailId < 0 ||
      mailId > this.mails.length - 1
    ) {
      this.openMailId = -1;
      this.openMailIdChange.emit(this.openMailId);
      return;
    }
    this.openMailId = mailId;
    this.openMailIdChange.emit(this.openMailId);
    this.readMails.push(this.mails[mailId].id);
    this.loadMailDetail.emit(mailId);
    this.scrollToPosition('mail-detail', 'start');
  }

  onScroll() {
    this.loadNextPage.emit();
  }

  openNewTab(id: number) {
    this.showDetail$.next({ id: id, type: 'double' });
    window.open(`/matching/${this.mailType}s/${this.mails[id].id}`, '_blank');
  }

  scrollToPosition(elementId: string, position: 'start' | 'center' = 'center') {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: position
      });
    }
  }
}
